module.exports = __webpack_public_path__ + "static/Lato-Semibold-8b4f872c5de19974857328d06d3fe48f.woff2";